import { render, staticRenderFns } from "./v-pagination.vue?vue&type=template&id=36ac9900"
import script from "./v-pagination.vue?vue&type=script&lang=js"
export * from "./v-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports